import { render } from "./ReturnsToInventory.vue?vue&type=template&id=21c8bc9c"
import script from "./ReturnsToInventory.vue?vue&type=script&lang=js"
export * from "./ReturnsToInventory.vue?vue&type=script&lang=js"

import "./ReturnsToInventory.vue?vue&type=style&index=0&id=21c8bc9c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__